import * as Constants from './Redux/action_types/EPAConstants';

import minValues from './../Datafiles/ConfigurationMinValues.json';
const configurationMinValues = minValues;

export const removeObject = (itemToRemove, isService, workload) => {
    if (workload.UserInputs.Environments.WorkloadType === Constants.BIG_DATA) {
        if (workload.UserInputs.Environments.Growth) {
            let rest;
            isService ?
                rest = workload.UserInputs.Environments['Growth'].Service.filter(item => item['@Service'] !== itemToRemove)
                :
                rest = workload.UserInputs.Environments['Growth'].Service.filter(item => item['@Name'] !== itemToRemove);
            workload.UserInputs.Environments['Growth'].Service = rest;
        }
    }
}

export const cleanupGrowth = (workload) => {
    if (workload.UserInputs.Environments.Growth) {
        let getObject;
        if (workload.UserInputs.Environments.WorkloadType === Constants.BIG_DATA) {
            workload.UserInputs.Environments.Functions.Function.forEach(x => {
                if (Array.isArray(x.Service)) {
                    x.Service.filter(elem => elem["@Selected"] == "false").forEach(filteredItem => {
                        getObject = workload.UserInputs.Environments['Growth'].Service.find(item => item['@Service'] === filteredItem['@Type']);
                        if (getObject) {
                            removeObject(getObject['@Service'], true, workload);
                        }
                    })
                }
                else {
                    if (x.Service["@Selected"] == "false" && x["@Type"] !== "Gateway Node" && x["@Type"] !== "Master Node") {
                        getObject = workload.UserInputs.Environments['Growth'].Service.find(item => item['@Service'] === x.Service['@Type']);
                        if (getObject) {
                            removeObject(getObject['@Service'], true, workload);
                        }

                    } else if (x.Service["@Selected"] === "false") {
                        getObject = workload.UserInputs.Environments['Growth'].Service.find(item => item['@Name'] === x['@Type']);
                        if (getObject) {
                            removeObject(getObject['@Name'], false, workload);
                        }
                    } else if (x.Service["@Selected"] === "true" && x["@Type"] === "Gateway Node" && isNaN(x.Service.Hardware["@NodesCount"])) {
                        getObject = workload.UserInputs.Environments['Growth'].Service.find(item => item['@Name'] === x['@Type']);
                        if (getObject) {
                            removeObject(getObject['@Name'], false, workload);
                        }
                    }
                }
            })
        } else {
            let index;
            if (!Array.isArray(workload.UserInputs.Environments.Growth.Host)) {
                let growthObject = workload.UserInputs.Environments.Growth.Host;
                workload.UserInputs.Environments.Growth.Host = [];
                workload.UserInputs.Environments.Growth.Host.push(growthObject);
            }
            index = workload.UserInputs.Environments.Growth.Host.findIndex(service => service["@SolutionType"] === "" && service["@RoleName"] === "");
            if (index > -1) {
                workload.UserInputs.Environments.Growth.Host.splice(index, 1);
            }
            workload.UserInputs.Environments.Environment.map(solution => {
                if (Array.isArray(solution.Templates.ServerDetails.Server)) {
                    solution.Templates.ServerDetails.Server.filter(role => role["@NodesCount"] === "0").map(unconfiguredRole => {
                        index = workload.UserInputs.Environments['Growth'].Host.findIndex(service => service["@SolutionType"] === solution["@SolutionType"] && service["@RoleName"] === unconfiguredRole["@RoleName"]);
                        if (index > -1) {
                            workload.UserInputs.Environments.Growth.Host.splice(index, 1);
                        }
                    })
                } else {
                    if (solution.Templates.ServerDetails.Server["@NodesCount"] === 0) {
                        index = workload.UserInputs.Environments['Growth'].Host.find(service => service["@SolutionType"] === solution["@SolutionType"] && service["@RoleName"] === solution.Templates.ServerDetails.Server["@RoleName"]);
                        if (index > -1) {
                            workload.UserInputs.Environments.Growth.Host.splice(index, 1);
                        }
                    }
                }
            })
            workload.UserInputs.Environments.ManagementHosts.Server.filter(role => role["@NodesCount"] === "0").map(unconfiguredRole => {
                index = workload.UserInputs.Environments['Growth'].Host.find(service => service["@SolutionType"] === unconfiguredRole["@RoleName"]);
                if (index > -1) {
                    workload.UserInputs.Environments.Growth.Host.splice(index, 1);
                }
            })
        }
    }
}




export const updateGrowthItem = (service, value, workload) => {
    if (workload.UserInputs.Environments.Growth) {
        cleanupGrowth(workload);
        let growthItem = workload.UserInputs.Environments.Growth.Service.find(item => item['@Service'] === service || item['@Name'] === service);
        if (growthItem) {
            if (isNaN(value) && service === 'Gateway Node') {
                let rest = workload.UserInputs.Environments['Growth'].Service.filter(item => item['@Name'] !== 'Gateway Node');
                workload.UserInputs.Environments['Growth'].Service = rest;
            } else {
                growthItem['@Nodes1Y'] = value;
                updateCalculations(growthItem, workload);
            }
        }
    }
}
export const updateEzemeralGrowthItems = (workload) => {
    let item = {};
    let oldGrowthObject = [...workload.UserInputs.Environments.Growth.Host];
    workload.UserInputs.Environments.Growth.Host = [];
    workload.UserInputs.Environments.Environment.map(x => {
        if (x["@isSelected"] === Constants.yES_) {
            x.Templates.ServerDetails.Server.map(role => {
                if (role["@NodesCount"] !== "0") {
                    let growthRate = "0";
                    const growthObjectIndex = oldGrowthObject.findIndex(growthItem => growthItem["@SolutionType"] === x["@SolutionType"] && growthItem["@RoleName"] === role["@RoleName"])
                    if (growthObjectIndex > -1) {
                        growthRate = oldGrowthObject[growthObjectIndex]["@GrowthRate"];
                    }
                    item["@GrowthRate"] = growthRate.toString();
                    item["@Nodes1Y"] = role["@NodesCount"].toString();
                    item["@Nodes2Y"] = "-";
                    item["@Nodes3Y"] = "-";
                    item["@Nodes4Y"] = "-";
                    item["@RoleName"] = role["@RoleName"];
                    item["@SolutionType"] = x["@SolutionType"];
                    updateCalculations(item, workload);
                    workload.UserInputs.Environments.Growth.Host.push({ ...item });
                }
            })
        }
    })
    let isGrowthGiven = false;
    if (workload.UserInputs.Environments.Growth.Host.filter(service => parseInt(service["@GrowthRate"], 10) > 0).length > 0) {
        isGrowthGiven = true;
    }
    workload.UserInputs.Environments.Growth.Host.map(service => {
        if (!isGrowthGiven) {
            service["@Nodes2Y"] = Constants.HYPHEN_;
            service["@Nodes3Y"] = Constants.HYPHEN_;
            service["@Nodes4Y"] = Constants.HYPHEN_;
        }
    })
}

export const updateCalculations = (itemToUpdate, workload) => {
    let value = parseInt(itemToUpdate["@GrowthRate"], 10);

    let nodes = parseInt(itemToUpdate["@Nodes1Y"], 10);
    if (workload.UserInputs.Environments.WorkloadType === Constants.BIG_DATA) {
        if (value === 0) {
            itemToUpdate["@Nodes2Y"] = '-';
            itemToUpdate["@Nodes3Y"] = '-';
        }
        else {
            if (itemToUpdate["@GrowthType"] === "Percentage") {
                value = value / 100;
                itemToUpdate["@Nodes2Y"] = Math.round(nodes * Math.pow(value + 1, 1));
                itemToUpdate["@Nodes3Y"] = Math.round(nodes * Math.pow(value + 1, 2));
            }
            else {
                itemToUpdate["@Nodes2Y"] = nodes + value;
                itemToUpdate["@Nodes3Y"] = nodes + (value * (2));
            }
        }
    } else {
        if (itemToUpdate["@RoleName"] === Constants.STORAGE_HOST_ROLE_NAME) {
            let RepFactor;
            let PersistentSize;
            let ServerQty;
            let UsableSize;
            let AdditionalHosts = 0;
            let TotalPersistentSize
            let usablePersistentStorage = 0;
            workload.UserInputs.Environments.Environment.map(x => {
                if (x["@SolutionType"] === itemToUpdate["@SolutionType"]) {
                    RepFactor = parseInt(x.Templates.ServerDetails.Requirements["@HDFSRepFactor"], 10);
                    PersistentSize = parseInt(x.Templates.ServerDetails.Requirements["@HDFSRawSize"], 10);
                    x.Templates.ServerDetails.Server.map(Server => {
                        if (Server["@RoleName"] === itemToUpdate["@RoleName"]) {
                            ServerQty = Server["@NodesCount"];
                            if (Array.isArray(Server.PersistentDisks)) {
                                Server.PersistentDisks.map(qty => {
                                    if (qty.Item[Constants.SIZE_ATTRIBUTE]) {
                                        usablePersistentStorage += parseInt(qty.Item["@qty"], 10) * parseFloat(qty.Item[Constants.SIZE_ATTRIBUTE]);
                                    }
                                })
                            }
                            UsableSize = (ServerQty * usablePersistentStorage) / RepFactor;

                            for (let i = 2; i < 5; i++) {
                                TotalPersistentSize = Math.round((PersistentSize * Math.pow(1 + (value / 100), i)));
                                if (TotalPersistentSize > UsableSize) {
                                    if (((TotalPersistentSize - UsableSize) / 60) > 0) {
                                        AdditionalHosts = Math.ceil(((TotalPersistentSize - UsableSize) / 60));
                                    }
                                }
                                itemToUpdate[`@Nodes${i}Y`] = (parseInt(itemToUpdate["@Nodes1Y"], 10) + AdditionalHosts).toString();;
                            }
                        }

                    })
                }
            })
        }
        else {
            value = value / 100;
            itemToUpdate["@Nodes2Y"] = Math.round(nodes * Math.pow(value + 1, 2)).toString();
            itemToUpdate["@Nodes3Y"] = Math.round(nodes * Math.pow(value + 1, 3)).toString();
            itemToUpdate["@Nodes4Y"] = Math.round(nodes * Math.pow(value + 1, 4)).toString();
        }
    }

}

export const validateApollo4200SFFDrives = (referenceDrive1, referenceDrive2, currentDrive) => {
    let isNVMEdrive = false;
    let isValid = true;
    if (currentDrive.toUpperCase().indexOf(Constants.NVME_) > -1) {
        isNVMEdrive = true;
    }
    function validationMethod(referenceDrive) {
        if (referenceDrive.toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[0]) > -1 || referenceDrive.toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[1]) > -1) {
            if (isNVMEdrive) {
                if (referenceDrive.toUpperCase().indexOf(Constants.NVME_) === -1) {
                    isValid = false;
                }
            } else {
                if (referenceDrive.toUpperCase().indexOf(Constants.NVME_) > -1) {
                    isValid = false;
                }
            }
        }
    }
    if (referenceDrive1) {
        validationMethod(referenceDrive1);
    }
    if (isValid && referenceDrive2) {
        validationMethod(referenceDrive2);
    }
    return isValid;
}

export const validateNVMEorSFFDrivesCount = (roleObject, maxSFFDriveQuantity) => {
    let isValid = true;
    let existingNVMEorSFFDriveCount = 0;
    let nonNVMEDrivesCount = 0;
    let apollo4200nonNVMEmaxDriveCount = 22;
    if (roleObject["@Name"] === Constants.HPE_APOLLO_4200_GEN10) {
        if (roleObject["@NodeDisk"].toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[0]) > -1 || roleObject["@NodeDisk"].toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[1]) > -1) {
            existingNVMEorSFFDriveCount += parseInt(roleObject["@StorageDiskQty"], 10);
        } else {
            nonNVMEDrivesCount += parseInt(roleObject["@StorageDiskQty"], 10);
        }
        if (roleObject["@Type"] !== Constants.GATEWAY_) {
            if (roleObject["@TStorageDrive"].toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[0]) > -1 || roleObject["@TStorageDrive"].toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[1]) > -1) {
                existingNVMEorSFFDriveCount += parseInt(roleObject["@TStorageDriveQty"], 10);
            } else {
                nonNVMEDrivesCount += parseInt(roleObject["@TStorageDriveQty"], 10);
            }
        }
        if (roleObject["@OSDisk"].toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[0]) > -1 || roleObject["@OSDisk"].toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[1]) > -1) {
            existingNVMEorSFFDriveCount += parseInt(roleObject["@OSDiskQty"], 10);
        } else {
            nonNVMEDrivesCount += parseInt(roleObject["@OSDiskQty"], 10);
        }
        if (roleObject["@OSDisk"].indexOf(Constants.M_2) > -1) {
            apollo4200nonNVMEmaxDriveCount = 24;
        }
        if (existingNVMEorSFFDriveCount > 0 && nonNVMEDrivesCount > apollo4200nonNVMEmaxDriveCount) {
            isValid = false;
        }
    }
    else {
        if (roleObject["@NodeDisk"].toUpperCase().indexOf(Constants.NVME_) > -1) {
            existingNVMEorSFFDriveCount += parseInt(roleObject["@StorageDiskQty"], 10);
        }
        if (roleObject["@Type"] !== Constants.GATEWAY_) {
            if (roleObject["@TStorageDrive"].toUpperCase().indexOf(Constants.NVME_) > -1) {
                existingNVMEorSFFDriveCount += parseInt(roleObject["@TStorageDriveQty"], 10);
            }
        }
        if (roleObject["@OSDisk"].toUpperCase().indexOf(Constants.NVME_) > -1) {
            existingNVMEorSFFDriveCount += parseInt(roleObject["@OSDiskQty"], 10);
        }
    }
    if (existingNVMEorSFFDriveCount > maxSFFDriveQuantity) {
        isValid = false;
    }
    return isValid;
}

export const nodeStorageDriveQuantityOnBlurValidation = (x, value, supportedListDetails) => {
    let NoOfNVMEDrives = 0;
    let NoOfNonNVMEDrives = 0;
    let remainingDrives = 0;
    let NonGPUMaxDrives = 0;
    if (((x["@OSDisk"].toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[1]) > -1 || x["@OSDisk"].toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[0]) > -1) && x["@Name"] === Constants.HPE_APOLLO_4200_GEN10) || x["@OSDisk"].toUpperCase().indexOf(Constants.NVME_) > -1) {
        NoOfNVMEDrives += parseInt(x["@OSDiskQty"], 10);
    } else {
        NoOfNonNVMEDrives += parseInt(x["@OSDiskQty"], 10);
    }
    if (((x["@TStorageDrive"].toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[1]) > -1 || x["@TStorageDrive"].toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[0]) > -1) && x["@Name"] === Constants.HPE_APOLLO_4200_GEN10) || x["@TStorageDrive"].toUpperCase().indexOf(Constants.NVME_) > -1) {
        NoOfNVMEDrives += parseInt(x["@TStorageDriveQty"], 10);
    } else {
        NoOfNonNVMEDrives += parseInt(x["@TStorageDriveQty"], 10);
    }
    if ((x["@Name"] === Constants.HPE_APOLLO_4200_GEN10 && (x["@NodeDisk"].toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[1]) > -1 || x["@NodeDisk"].toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[0]) > -1)) || x["@NodeDisk"].toUpperCase().indexOf(Constants.NVME_) > -1) {
        NonGPUMaxDrives = supportedListDetails[x["@Name"]].MaxNVMeDrives;
        remainingDrives = NonGPUMaxDrives - NoOfNVMEDrives;
    }
    else {
        NonGPUMaxDrives = supportedListDetails[x["@Name"]].MaxDrives;
        if (x["@Name"] === Constants.HPE_APOLLO_4200_GEN10 && NoOfNVMEDrives > 0) {
            if (x["@OSDisk"].indexOf(Constants.M_2) > -1) {
                NonGPUMaxDrives = 26;
            } else {
                NonGPUMaxDrives = 24;
            }
            remainingDrives = NonGPUMaxDrives - NoOfNonNVMEDrives;
        }
        else {
            remainingDrives = NonGPUMaxDrives - NoOfNonNVMEDrives - NoOfNVMEDrives;
        }
    }
    if (parseInt(value, 10) <= remainingDrives) {
        x["@StorageDiskQty"] = value;
    } else {
        if (remainingDrives < 0) {
            x["@StorageDiskQty"] = "0";
        } else {
            x["@StorageDiskQty"] = remainingDrives.toString();
        }
    }
}

export const validateDriveChange = (referenceDrive1, referenceDrive2, currentDrive, serverName, tenantStorageQty = null, type = '') => {
    var isValid = true;
    let validationMethod = (referenceDrive) => {
        //In Apollo 4200 LFF and SFF can mix
        //In DL380 OS drives(SFF) can mix LFF drives
        if (serverName !== Constants.HPE_APOLLO_4200_GEN10 && serverName !== Constants.HPE_APOLLO_4200_GEN10_PLUS) {
            if (referenceDrive.indexOf(Constants.LFF_) > -1 || referenceDrive.toUpperCase().indexOf(Constants.INCHES_THREE) > -1) {
                if ((currentDrive.indexOf(Constants.SFF_DESCRIPTIONS[0]) > -1 || currentDrive.toUpperCase().indexOf(Constants.INCHES_) > -1) && serverName !== Constants.PROLIANT_DL380_GEN10 && serverName !== Constants.PROLIANT_DL385_GEN10_PLUS) {
                    isValid = false;
                }
            } else if ((referenceDrive.indexOf(Constants.SFF_DESCRIPTIONS[0]) > -1 || referenceDrive.toUpperCase().indexOf(Constants.INCHES_) > -1) && serverName !== Constants.PROLIANT_DL380_GEN10 && serverName !== Constants.PROLIANT_DL385_GEN10_PLUS) {
                if (currentDrive.indexOf(Constants.LFF_) > -1 || currentDrive.toUpperCase().indexOf(Constants.INCHES_THREE) > -1) {
                    isValid = false;
                }
            }
        }
        if (referenceDrive.indexOf(Constants.SATA_) > -1 && referenceDrive.indexOf(Constants.HDD_) > -1) {
            //In Apollo 4200 LFF SATA HDD can mix SFF SAS drives or SFF SATA HDD can mix with LFF SAS drives.
            if (serverName === Constants.HPE_APOLLO_4200_GEN10) {
                if (currentDrive.indexOf(Constants.SAS_) > -1) {
                    if ((referenceDrive.indexOf(Constants.LFF_) > -1 || referenceDrive.toUpperCase().indexOf(Constants.INCHES_THREE) > -1) && (currentDrive.indexOf(Constants.LFF_) > -1 || currentDrive.toUpperCase().indexOf(Constants.INCHES_THREE) > -1)) {
                        isValid = false;
                    }
                    if ((referenceDrive.indexOf(Constants.SFF_DESCRIPTIONS[0]) > -1 || referenceDrive.toUpperCase().indexOf(Constants.INCHES_) > -1) && (currentDrive.indexOf(Constants.SFF_DESCRIPTIONS[0]) > -1 || currentDrive.toUpperCase().indexOf(Constants.INCHES_) > -1)) {
                        isValid = false;
                    }
                }
            } else {
                if (currentDrive.indexOf(Constants.SAS_) > -1 || currentDrive.indexOf(Constants.NVMe_) > -1) {
                    isValid = false;
                }
            }
        } else if (referenceDrive.indexOf(Constants.SAS_) > -1 || (referenceDrive.indexOf(Constants.NVMe_) > -1 && serverName !== Constants.HPE_APOLLO_4200_GEN10)) {
            if (currentDrive.indexOf(Constants.SATA_) > -1 && currentDrive.indexOf(Constants.HDD_) > -1) {
                if (serverName === Constants.HPE_APOLLO_4200_GEN10) {
                    if ((referenceDrive.indexOf(Constants.LFF_) > -1 || referenceDrive.toUpperCase().indexOf(Constants.INCHES_THREE) > -1) && (currentDrive.indexOf(Constants.LFF_) > -1 || currentDrive.toUpperCase().indexOf(Constants.INCHES_THREE) > -1)) {
                        isValid = false;
                    }
                    if ((referenceDrive.indexOf(Constants.SFF_DESCRIPTIONS[0]) > -1 || referenceDrive.toUpperCase().indexOf(Constants.INCHES_) > -1) && (currentDrive.indexOf(Constants.SFF_DESCRIPTIONS[0]) > -1 || currentDrive.toUpperCase().indexOf(Constants.INCHES_) > -1)) {
                        isValid = false;
                    }
                } else {
                    isValid = false;
                }
            }
        }
    }
    if (serverName !== Constants.SYN_480_GEN10 && serverName !== Constants.HPE_APOLLO_4500_GEN10) {
        if (referenceDrive1) {
            if (tenantStorageQty === 0 && type === 'ephemeral') {
            } else {
                validationMethod(referenceDrive1);
            }
        }
        if (isValid) {
            if (referenceDrive2) {
                if (tenantStorageQty === 0 && type === 'osdrive') {
                } else {
                    validationMethod(referenceDrive2);
                }
            }
        }
    }
    return isValid;
}

export const getGatewayandControllerHost = (workload, hostType) => {
    let nonGPUServers = [];
    let serverName = Constants.PROLIANT_XL220N_GEN10_PLUS;
    let selectedServices = [];
    workload.UserInputs.Environments.Environment.filter(solution => solution["@isSelected"] === Constants.yES_).map(selectedSolution => {
        if (selectedSolution.NonGPUValue.isCalculated === Constants.tRUE_ || selectedSolution.GPUValue.isCalculated === Constants.tRUE_ || selectedSolution.StorageValue.isCalculated === Constants.tRUE_) {
            selectedServices.push(selectedSolution["@SolutionType"]);
        }
        if (selectedSolution.NonGPUValue.isCalculated === Constants.tRUE_) {
            if (selectedSolution.Templates.ServerDetails.Server.find(role => role["@Type"] === Constants.NONGPU_)) {
                nonGPUServers.push(selectedSolution.Templates.ServerDetails.Server.find(role => role["@Type"] === Constants.NONGPU_)["@Name"]);
            }
        }
    })
    if (hostType === Constants.GATEWAY_ && selectedServices.length === 1 && selectedServices[0] === Constants.CAAS_) {
        serverName = Constants.SYN_480_GEN10;
    } else if (selectedServices.indexOf(Constants.MLOPS) > -1 || selectedServices.indexOf(Constants.CAAS_) > -1) {
        serverName = Constants.PROLIANT_DL360_GEN10;
    } else if (nonGPUServers.length > 0) {
        let sameServerInAllRoles = true;
        for (let i = 0; i < nonGPUServers.length; i++) {
            if (nonGPUServers[i] !== nonGPUServers[0]) {
                sameServerInAllRoles = false;
            }
        }
        if (sameServerInAllRoles) {
            serverName = Constants.PROLIANT_XL220N_GEN10_PLUS;
        }
    }
    return serverName;
}

export const updateControllerHostCount = (workload, isHAIncluded) => {
    let kubernetesTemplate = "";
    let EPICTemplate = "";
    let controllerHostCount = 0;
    let controllerObject = workload.UserInputs.Environments.ManagementHosts.Server.find(role => role["@Type"] === Constants.CONTROLLER_);
    let oldControllerHostCount = parseInt(controllerObject["@NodesCount"], 10);
    if (controllerObject["@VMWare"] === Constants.tRUE_) {
        controllerHostCount = 3;
    }
    else {
        workload.UserInputs.Environments.Environment.filter(solution => solution["@isSelected"] === Constants.yES_).map(selectedSolution => {
            if (!kubernetesTemplate) {
                kubernetesTemplate = selectedSolution.Templates.Template.find(template => template["@ConfigType"] === Constants.KUBERNETES_ && template["@Type"] !== Constants.NONE_ && !(selectedSolution['@SolutionType'] === Constants.MLOPS && template["@InputMode"] === Constants.IMAGE_PROCESSING));
            }
            if (!EPICTemplate) {
                EPICTemplate = selectedSolution.Templates.Template.find(template => template["@ConfigType"] === Constants.EPIC_ && template["@Type"] !== Constants.NONE_ && !(selectedSolution['@SolutionType'] === Constants.MLOPS && template["@InputMode"] === Constants.IMAGE_PROCESSING));
            }
        });
        if (kubernetesTemplate) {
            controllerHostCount = 6;
        } else {
            controllerHostCount = 3;
        }
    }
    if (!isHAIncluded) {
        controllerHostCount = 2;
    }

    if (controllerObject["@VMWare"] === Constants.tRUE_) {
        controllerHostCount = 2;
    } else {
        if (controllerObject["@HAIncluded"] === Constants.tRUE_) {
            controllerHostCount = 3;
        } else {
            controllerHostCount = 1;
        }
    }

    if (controllerHostCount > 0) {
        controllerObject["@NodesCount"] = controllerHostCount.toString();
    }
}

export const updateMasterHostCount = (workload, isHAIncluded) => {
    let kubernetesTemplate = "";
    let EPICTemplate = "";
    let masterHostCount = 0;
    let masterObject = workload.UserInputs.Environments.ManagementHosts.Server.find(role => role["@Type"] === Constants.MASTER_);
    let oldControllerHostCount = parseInt(masterObject["@NodesCount"], 10);
    if (masterObject["@VMWare"] === Constants.tRUE_) {
        masterHostCount = 3;
    }
    else {
        workload.UserInputs.Environments.Environment.filter(solution => solution["@isSelected"] === Constants.yES_).map(selectedSolution => {
            if (!kubernetesTemplate) {
                kubernetesTemplate = selectedSolution.Templates.Template.find(template => template["@ConfigType"] === Constants.KUBERNETES_ && template["@Type"] !== Constants.NONE_ && !(selectedSolution['@SolutionType'] === Constants.MLOPS && template["@InputMode"] === Constants.IMAGE_PROCESSING));
            }
            if (!EPICTemplate) {
                EPICTemplate = selectedSolution.Templates.Template.find(template => template["@ConfigType"] === Constants.EPIC_ && template["@Type"] !== Constants.NONE_ && !(selectedSolution['@SolutionType'] === Constants.MLOPS && template["@InputMode"] === Constants.IMAGE_PROCESSING));
            }
        });
        if (kubernetesTemplate) {
            masterHostCount = 6;
        } else {
            masterHostCount = 3;
        }
    }
    if (!isHAIncluded) {
        masterHostCount = 2;
    }

    if (masterObject["@VMWare"] === Constants.tRUE_) {
        masterHostCount = 2;
    } else {
        if (masterObject["@HAIncluded"] === Constants.tRUE_) {
            masterHostCount = 3;
        } else {
            masterHostCount = 1;
        }
    }


    if (masterHostCount > 0) {
        masterObject["@NodesCount"] = masterHostCount.toString();
    }
}

export const updateFinishButton = (workload, displayWarning, isSizeEnabled) => {
    let result = false;
    if (workload.UserInputs.Environments.WorkloadType === Constants.BLUE_DATA) {
        if (workload.UserInputs.Environments.Environment.find(solution => solution["@isSelected"] === Constants.yES_)) {
            if (!displayWarning) {
                if (!isSizeEnabled) {
                    result = true;
                }
            }
        }
    }
    return result;
}

export const filterDriveList = (rawData, value) => {
    const filteredOptions = [];
    rawData.map(drive => {
        if (drive.indexOf(value) === -1) {
            filteredOptions.push(drive);
        }
    })
    return filteredOptions;
}


export const filterOptions = (rawData, configuration, role, field) => {
    if (configuration === Constants.POWER_) {
        return rawData;
    }
    const filteredOptions = [];
    let baseValue = ''
    if (field === Constants.PROCESSOR_) {
        if (role === Constants.STORAGE_) {
            rawData.map(proc => {
                if (parseInt(proc.split('/')[2].split(' ')[1], 10) >= 16) {
                    filteredOptions.push(proc);
                }
            })
        } else {
            baseValue = parseInt(configurationMinValues[configuration][role]["@procSpecInt"].split(' ')[0], 10);
            rawData.map(proc => {
                if (parseInt(proc.split('/')[3].split(' ')[1], 10) > baseValue) {
                    filteredOptions.push(proc);
                }
            })
        }

    }
    if (field === Constants.MEMORY_) {
        baseValue = parseInt(configurationMinValues[configuration][role]["@Memory"].split(' ')[0], 10);
        rawData.map(memory => {
            if (parseInt(memory.split(' ')[0], 10) >= baseValue) {
                filteredOptions.push(memory);
            }
        })
    }
    if (field.indexOf(Constants.DISK_) > -1) {
        const baseDriveCapacity = parseFloat(configurationMinValues[configuration][role][`@${field}`].split(' ')[0].split(Constants.TB_)[0], 10);
        const baseDriveType = configurationMinValues[configuration][role][`@${field}`].split(' ')[1];
        rawData.map(drive => {
            let driveCapacity = drive.split(' ')[1];
            if (driveCapacity === Constants.EDGELINE_) {
                driveCapacity = drive.split(' ')[2];
            }
            if (drive.indexOf(baseDriveType) > -1) {
                if (driveCapacity.indexOf(Constants.TB_) > -1) {
                    if (parseFloat(driveCapacity.split(Constants.TB_)[0], 10) >= baseDriveCapacity) {
                        filteredOptions.push(drive);
                    }
                } else if (driveCapacity.indexOf(Constants.GB_) > -1) {
                    if (parseFloat(driveCapacity.split(Constants.GB_)[0] / 1024, 10) >= baseDriveCapacity) {
                        filteredOptions.push(drive);
                    }
                }
            } else {
                filteredOptions.push(drive);
            }
        })
    }
    if (filteredOptions.length === 0) {
        return rawData;
    }
    return filteredOptions;
}

export const updateMasterandGatewayServices = (workload) => {
    let isDataLakeSelected = false;
    let otherServiceSelected = false;
    let isDataFabricSelected = false;
    workload.UserInputs.Environments.Functions.Function.map(Function => {
        if (Array.isArray(Function.Service)) {
            Function.Service.map(service => {
                if (service["@Type"] === Constants.DATA_LAKE) {
                    if (service["@Selected"] === Constants.tRUE_) {
                        isDataLakeSelected = true;
                    }
                } else {
                    if (service["@Selected"] === Constants.tRUE_) {
                        otherServiceSelected = true;
                    }
                }
            })
        } else {
            if (Function["@Type"] === Constants.IOT_) {
                if (Function.Service["@Selected"] === Constants.tRUE_) {
                    otherServiceSelected = true;
                }
            }
        }
    });
    if (workload.UserInputs.Environments.HadoopServices.ServiceLicenses.DataFabric["@IsSelected"] === Constants.tRUE_) {
        isDataFabricSelected = true;
    }
    if (isDataLakeSelected && isDataFabricSelected && !otherServiceSelected) {
        workload.UserInputs.Environments.Functions.Function.map(Function => {
            if (!Array.isArray(Function.Service)) {
                if (Function["@Type"] === Constants.MASTER_NODE || Function["@Type"] === Constants.GATEWAY_NODE) {
                    Function.Service["@Selected"] = Constants.fALSE_;
                }
            }
        })
    } else {
        workload.UserInputs.Environments.Functions.Function.map(Function => {
            if (!Array.isArray(Function.Service)) {
                if (Function["@Type"] === Constants.MASTER_NODE || Function["@Type"] === Constants.GATEWAY_NODE) {
                    Function.Service["@Selected"] = Constants.tRUE_;
                }
            }
        })
    }
}

export const updateServiceLicenses = (serviceLicenses, serviceSupportedList) => {
    if (serviceLicenses && serviceSupportedList) {
        const hortonWorkandCloudEraUpdate = (HortonWorkorCloudEraObject) => {
            if (Array.isArray(HortonWorkorCloudEraObject.License)) {
                HortonWorkorCloudEraObject.License.map(license => {
                    if (license[Constants.ATTRIBUTE_TYPE] === Constants.HORTONWORK_ENT_PLUS) {
                        license[Constants.ATTRIBUTE_ISSELECTED] = Constants.fALSE_;
                        license[Constants.ATTRIBUTE_DESCRIPTION] = Constants.NONE_;
                    } else {
                        let supportedOptions = [];
                        let service = serviceSupportedList.find(supportedLicense => supportedLicense[Constants.ATTRIBUTE_TYPE] === license[Constants.ATTRIBUTE_TYPE])
                        if (service) {
                            if (!Array.isArray(service.Item)) {
                                let option = service.Item;
                                service.Item = [option];
                            }
                            supportedOptions = service.Item;
                            if (supportedOptions.indexOf(license[Constants.ATTRIBUTE_DESCRIPTION]) === -1) {
                                license[Constants.ATTRIBUTE_DESCRIPTION] = Constants.NONE_;
                                license[Constants.ATTRIBUTE_ISSELECTED] = Constants.fALSE_;
                            }
                        }
                    }
                })
            }
        }
        if (serviceLicenses.Hortonworks) {
            hortonWorkandCloudEraUpdate(serviceLicenses.Hortonworks);
        }
        if (serviceLicenses.Cloudera) {
            hortonWorkandCloudEraUpdate(serviceLicenses.Cloudera);
        }
    }
}
export const serverChangeCompatibilityCheck = (workload, selectedServer, supportedList, type, title) => {
    let shouldChangeServer = true;
    let warningMessage = "";
    let MixedDrives = [];
    let supportedDrives = [];
    let driveCount = 0;
    let NVMEDriveCount = 0;
    let isNVMeDrivePresent = false;
    let isSFFDrivePresent = false;
    let SFFDriveCount = 0;
    let selectedServerSupportedList = supportedList.find(service => service[Constants.FUNCTIONNAME_] === type && service[Constants.SERVICENAME_] === title).totalList[selectedServer];
    let maxDrives = selectedServerSupportedList.iDataDiskQty;
    let maxNVMEDrives = selectedServerSupportedList.iMaxNVMeDrive;
    workload.UserInputs.Environments.Functions.Function.map(Function => {
        if (Function[Constants.ATTRIBUTE_TYPE] === type) {
            if (Array.isArray(Function.Service)) {
                MixedDrives = Function.Service.find(service => service[Constants.ATTRIBUTE_TYPE] === title)[Constants.DATADISKS_];
            } else {
                MixedDrives = Function.Service[Constants.DATADISKS_];
            }
        }
    })
    selectedServerSupportedList.DataDiskList.map(drive => {
        supportedDrives.push(drive.StrDrive);
    })
    MixedDrives.map(drive => {
        if (shouldChangeServer) {
            if (supportedDrives.indexOf(drive.Item[Constants.ATTRIBUTE_dISK]) === -1) {
                shouldChangeServer = false;
                warningMessage = Constants.SERVERCHANGE_WARNINGTEXT;
            }
        }
        if (drive.Item[Constants.ATTRIBUTE_dISK].indexOf(Constants.NVME_) > -1) {
            isNVMeDrivePresent = true;
            NVMEDriveCount += parseInt(drive.Item[Constants.ATTRIBUTE_qTY], 10);
        }
        if (selectedServer === Constants.HPE_APOLLO_4200_GEN10 && drive.Item[Constants.ATTRIBUTE_dISK].indexOf(Constants.SFF_DESCRIPTIONS[0]) > -1) {
            isSFFDrivePresent = true;
            SFFDriveCount += parseInt(drive.Item[Constants.ATTRIBUTE_qTY], 10);
        } else {
            driveCount += parseInt(drive.Item[Constants.ATTRIBUTE_qTY], 10);
        }
    })

    if (selectedServer === Constants.HPE_APOLLO_4200_GEN10 && shouldChangeServer && (isNVMeDrivePresent || isSFFDrivePresent)) {
        maxDrives = 22;
        if (isSFFDrivePresent) {
            if (SFFDriveCount > maxNVMEDrives) {
                shouldChangeServer = false;
                warningMessage = Constants.SERVERCHANGE_WARNINGTEXT;
            }
        }
    }

    if (shouldChangeServer && (driveCount > maxDrives || NVMEDriveCount > maxNVMEDrives)) {
        shouldChangeServer = false;
        warningMessage = Constants.SERVERCHANGE_WARNINGTEXT;
    }
    return [shouldChangeServer, warningMessage];
}



// WEBPACK FOOTER //
// ./src/SizerUI/commonLogic.js